// extracted by mini-css-extract-plugin
export default {"description":"day-of-week-time-slot-preset_description__44WBC","timeSlotButton":"day-of-week-time-slot-preset_timeSlotButton__vq+JJ"};